import { createTheme, lighten } from '@mui/material/styles';

const svceGreen = '#0EA28A';
const svceBlack = '#0a2333';
const svceWhite = '#FFF';
const svceDarkGreen = '#029984';
const svceDarkGray = '#475467';

// Pulled out of Figma
const codGray = '#131313';
const turbine = svceGreen;
const gridGreen = '#70c165';
const gridGreenLight = '#F5FFF5';
const gridGreenDark = '#4e8746';
const teal = '#a3d9d6';
const orange = '#f68d37';
const darkBlue = '#003863';
const gray = '#a3a7a9';
const darkGray = '#475467';
const cloudGray = '#e4e4e4';

const nonSelfReferentialTheme = createTheme({
  palette: {
    primary: {
      main: svceGreen,
      light: svceWhite,
      dark: svceDarkGreen,
      contrastText: svceBlack,
    },
    secondary: {
      main: svceBlack,
      light: svceGreen,
      dark: svceDarkGreen,
      contrastText: svceWhite,
    },
    svce: {
      codGray,
      turbine,
      gridGreen,
      teal,
      orange,
      darkBlue,
      gray,
      darkGray,
      cloudGray,
    },
    gray: {
      100: '#F9FAFB',
      200: '#F1F1F1',
      250: '#F5F5F5',
      300: '#e0e0e0',
      400: '#ACACAC',
      600: '#666666',
      900: '#011627',
    },
    green: {
      100: '#ECFDF3',
      200: '#badbd3',
      400: '#02ca9d',
      600: '#029875',
      700: '#027a48',
    },
    blue: {
      500: '#4dace9',
    },
    yellow: {
      50: '#FFFCF5',
      300: '#FEC84B',
    },
    red: {
      700: '#B54708',
    },
  },
  typography: {
    fontFamily: 'Proxima Nova, gotham, sans-serif',
    h1: {
      fontSize: '48px',
      lineHeight: '108.333%',
      fontWeight: 600,
    },
    h2: {
      fontSize: '20px',
      lineHeight: '30px',
      fontWeight: 600,
    },
    h6: {
      fontSize: '18px',
      lineHeight: '1.5em',
      fontWeight: 400,
      color: svceBlack,
    },
  },
  shape: {
    svceBorderRadius: '50px',
    resourceCardBorderRadius: '4px',
  },
  boxShadows: {
    header: '0px 0px 16px rgba(140, 138, 136, 0.5), 8px 8px 32px rgba(89, 88, 87, 0.25)',
  },
});

export const theme = createTheme(nonSelfReferentialTheme, {
  palette: {
    svceGreen: nonSelfReferentialTheme.palette.augmentColor({
      color: {
        main: svceGreen,
        contrastText: svceWhite,
      },
      name: 'svceGreen',
    }),
    whiteButton: nonSelfReferentialTheme.palette.augmentColor({
      color: {
        main: svceWhite,
        light: lighten(svceGreen, 0.3),
        dark: lighten(svceGreen, 0.9),
        contrastText: svceGreen,
      },
      name: 'white',
    }),
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          '&.MuiButton-root': {
            fontSize: '1rem',
          },
          '&:focus-visible': {
            outline: '1px solid',
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          fontWeight: 500,
          '&.Mui-selected': {
            color: nonSelfReferentialTheme.palette.common.white,
          },
          '&:focus-visible': {
            outline: `1px solid ${nonSelfReferentialTheme.palette.common.black}`,
            '&.Mui-selected': {
              outlineOffset: '1px',
            },
          },
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          // turn off the translateZ(0) transform MUI adds for the shimmer animation
          transform: 'none',
        },
      },
    },
  },
});
